import { defineStore } from 'pinia'
import { routes } from '~/config/constants'

const initialState = -1
export const useNavigationStore = defineStore('navigation', () => {
    // State
    const step = ref(initialState)
    const params = ref(null)
    const acceptedTerms = ref(false)

    const total = routes.length

    // Actions
    const nextStep = async () => {
        step.value++
        await navigateTo(routes[step.value].url)
    }

    const previousStep = async () => {
        step.value--
        if (step.value < 0) {
            navigateTo('/')
        }
        await navigateTo(routes[step.value].url)
    }

    const goToStep = async (id) => {
        step.value = id
        await navigateTo(routes[step.value].url)
    }
    const clear = () => {
        step.value = initialState
        acceptedTerms.value = false
    }

    return {
        step,
        total,
        params,
        acceptedTerms,
        nextStep,
        previousStep,
        goToStep,
        clear
    }
},
{
    persist: true,
})
